module.exports = __webpack_public_path__ + "img/card-ai.6801fe9c.svg";